export default __webpack_public_path__ + "static/bg-prev-3f982c73025bb6a33ff6154eb6a09e15.png";